import { BrowserRouter } from 'react-router-dom'
import { AppRoutes } from './router'
import ScrollToTop from "@/components/feature/ScrollToTop";
import GlobalPopup from "@/components/feature/GlobalPopup";
import { HelmetProvider } from 'react-helmet-async';

function App() {
  return (
    <HelmetProvider>
      <BrowserRouter basename={__BASE_PATH__}>
        <ScrollToTop />
        <GlobalPopup />
        <AppRoutes />
      </BrowserRouter>
    </HelmetProvider>
  )
}

export default App